import React, {FC, memo, useEffect} from "react";
import {Button, Progress, Result, Space} from "antd";
import LayoutStandard from "../LayoutStandard/LayoutStandard";
import Spin from "../Spin/Spin";
import css from "./LoadingContent.less";

type LoadingContentProps = {
    content?: string | React.ReactNode;
    style?: React.CSSProperties;
    loading?: boolean;
    className?: string;
};

const LoadingContent: FC<LoadingContentProps> = ({content, style, loading, className}) => {
    const renderLoadingIndicator = () => {
        if (!loading) return null;

        return (
            <div style={{margin: "16px 0"}}>
                <Progress
                    percent={100}
                    status="active"
                    showInfo={false}
                    strokeColor={{
                        "0%": "#108ee9",
                        "100%": "#87d068",
                    }}
                />
                <div style={{textAlign: "center", marginTop: 0}}>{content}</div>
            </div>
        );
    };

    if (content && (loading || loading === undefined)) {
        // if (loading) {
        return (
            <Space direction="vertical" size={16} className={className ?? css.root} style={style}>
                <Spin />
                {renderLoadingIndicator()}
                {/* {content} */}
            </Space>
        );
    }

    const defaultContent = (
        <Space direction="vertical" size={16} className={className ?? css.root} style={{textAlign: "center", ...style}}>
            <Spin />
            <div>{"Inhalte werden geladen"}</div>
        </Space>
    );

    return defaultContent;
};

type LoadableLoadingProps = {
    isLoading: boolean;
    pastDelay: boolean;
    timedOut: boolean;
    error: any;
    retry: () => void;
};

/**
 * Loading-Komponente für öffentliche Seiten (Login, Setup, NotFound, etc.)
 * ohne LayoutStandard-Wrapper. Zeigt bei Chunk-Load-Fehlern einen Reload-Button.
 */
export const LoadingPublic: FC<LoadableLoadingProps> = ({error}) => {
    useEffect(() => {
        if (error) {
            // Absichtlich console.error statt logger: Chunk-Load schlägt fehl
            // BEVOR der App-Logger-Client (Auth/Tenant-Kontext) verfügbar ist.
            // eslint-disable-next-line no-console
            console.error("[LoadingPublic] chunk load failed", error);
        }
    }, [error]);
    if (error) {
        return (
            <Result
                status="warning"
                title="Seite konnte nicht geladen werden"
                subTitle="Bitte lade die Seite neu. Falls das Problem bestehen bleibt, kontaktiere den Support."
                extra={
                    <Button type="primary" onClick={() => window.location.reload()}>
                        Seite neu laden
                    </Button>
                }
            />
        );
    }
    return <LoadingContent />;
};

export const LoadingLoggedIn: FC<LoadableLoadingProps> = ({error}) => {
    useEffect(() => {
        if (error) {
            // Absichtlich console.error statt logger: Chunk-Load schlägt fehl
            // BEVOR der App-Logger-Client (Auth/Tenant-Kontext) verfügbar ist.
            // eslint-disable-next-line no-console
            console.error("[LoadingLoggedIn] chunk load failed", error);
        }
    }, [error]);
    if (error) {
        return (
            <LayoutStandard
                main={
                    <Result
                        status="warning"
                        title="Seite konnte nicht geladen werden"
                        subTitle="Bitte lade die Seite neu. Falls das Problem bestehen bleibt, kontaktiere den Support."
                        extra={
                            <Button type="primary" onClick={() => window.location.reload()}>
                                Seite neu laden
                            </Button>
                        }
                    />
                }
            />
        );
    }
    return <LayoutStandard main={<LoadingContent />} />;
};

export default memo(LoadingContent);
